import axios from 'axios';
import React, { useEffect, useState } from 'react';
import MoonLoader from 'react-spinners/MoonLoader';
import { ToastContainer, toast } from 'react-toastify';
import { Bar, BarChart, LabelList, Legend, ResponsiveContainer, Tooltip, XAxis } from 'recharts';

function Last7Days({ IP, TOKEN }) {

    const [last7DaysAttSummaryNGIT, setLast7DaysAttSummaryNGIT] = useState([])
    const [last7DaysAttSummaryKMIT, setLast7DaysAttSummaryKMIT] = useState([])
    const [isSessionsLoading, setSessionsLoading] = useState(false)

    const get7SessionsAttSummaryNGIT = async () => {
        setSessionsLoading(true)
        var parameters = { token: TOKEN, college: 'NGIT' }
        await axios.post(`http://${IP}/get7sessionsattsummary-ngit`, parameters)
            .then(res => {
                if (res.data.error == true) {
                    notifyError(res.data.msg)
                }
                if (res.data.error == false) {
                    setLast7DaysAttSummaryNGIT(res.data.msg.sevensessionssummary)
                }
            })
            .catch((e) => console.log(e))
    }

    const get7SessionsAttSummaryKMIT = async () => {
        setSessionsLoading(true)
        var parameters = { token: TOKEN, college: 'KMIT' }
        await axios.post(`http://${IP}/get7sessionsattsummary-kmit`, parameters)
            .then(res => {
                if (res.data.error == true) {
                    notifyError(res.data.msg)
                }
                if (res.data.error == false) {
                    setLast7DaysAttSummaryKMIT(res.data.msg.sevensessionssummary)
                }
            })
            .catch((e) => console.log(e))
        setSessionsLoading(false)
    }

    useEffect(() => {
        get7SessionsAttSummaryKMIT()
    }, [])

    useEffect(() => {
        get7SessionsAttSummaryNGIT()
    }, [])

    const notifyError = (msg) => {
        toast.error(msg, {
            toastId: 3,
            position: "top-center",
            autoClose: 3000,
            hideProgressBar: true,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            width: "fit-content"
        });
    }

    return (
        <div>
            <div className='row pb-3'>
                <div className='col-md-6 bg-white m-auto rounded mt-4 AD-chart' style={{ width: 600, height: 300 }}>
                    <div className='d-flex justify-content-between'>
                        <h6 className='ps-1 pt-3 py-2'>KMIT Attendance : Last 7 sessions</h6>
                        {/* <div className='me-3'><span className='text-muted me-1'>Overall (%) : </span><h6 className='d-inline'>{}%</h6></div> */}
                    </div>
                    {
                        isSessionsLoading ?
                            <MoonLoader
                                className='mx-auto moonloader'
                                color="#012951"
                                loading={isSessionsLoading}
                                speedMultiplier={1}
                            />
                            :
                            <ResponsiveContainer>
                                <BarChart
                                    margin={{ top: 15, bottom: 60 }}
                                    // className="bg-white"
                                    // width={700}
                                    // height={300}
                                    data={last7DaysAttSummaryKMIT}
                                >
                                    <XAxis dataKey="name" fontSize={10} />
                                    {/* <YAxis fontSize={10}/> */}
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="present" barSize={30} fill="#012951" background={{ fill: '#c4c2c2' }} >
                                        <LabelList dataKey="present" position="top" fontSize={11} />
                                    </Bar>
                                    <Bar dataKey="absent" barSize={30} fill="#f78716" background={{ fill: '#c4c2c2' }} >
                                        <LabelList dataKey="absent" position="top" fontSize={11} />
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                    }
                </div>
                <div className='col-md-6 bg-white m-auto rounded mt-4 AD-chart' style={{ width: 600, height: 300 }}>
                    <div className='d-flex justify-content-between'>
                        <h6 className='ps-1 pt-3 py-2'>NGIT Attendance : Last 7 sessions</h6>
                        {/* <div className='me-3'><span className='text-muted me-1'>Overall (%) : </span><h6 className='d-inline'>{}%</h6></div> */}
                    </div>
                    {
                        isSessionsLoading ?
                            <MoonLoader
                                className='mx-auto moonloader'
                                color="#012951"
                                loading={isSessionsLoading}
                                speedMultiplier={1}
                            />
                            :
                            <ResponsiveContainer>
                                <BarChart
                                    margin={{ top: 15, bottom: 60 }}
                                    // className="bg-white"
                                    // width={700}
                                    // height={300}
                                    data={last7DaysAttSummaryNGIT}
                                >
                                    <XAxis dataKey="name" fontSize={10} />
                                    {/* <YAxis fontSize={10} /> */}
                                    <Tooltip />
                                    <Legend />
                                    <Bar dataKey="present" barSize={30} fill="#012951" background={{ fill: '#c4c2c2' }} >
                                        <LabelList dataKey="present" position="top" fontSize={11} />
                                    </Bar>
                                    <Bar dataKey="absent" barSize={30} fill="#f78716" background={{ fill: '#c4c2c2' }} >
                                        <LabelList dataKey="absent" position="top" fontSize={11} />
                                    </Bar>
                                </BarChart>
                            </ResponsiveContainer>
                    }
                </div>
            </div>
            <ToastContainer />
        </div>
    );
}

export default Last7Days;